import { createFileRoute, redirect, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { MailboxesClient } from "@/features/mail/MailboxesClient";
import { listMailboxes, mailKeys } from "@/features/mail/mail.api";
import { listUsers } from "@/features/users/users.api";

export const Route = createFileRoute("/_shell/mail/mailboxes")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) {
      throw redirect({ to: "/tasks" });
    }
  },
  component: MailboxesScreen,
});

function MailboxesScreen() {
  const { t } = useTranslation();

  const { session } = Route.useRouteContext();
  const mailboxesQuery = useQuery({
    queryKey: mailKeys.mailboxesAdmin,
    queryFn: () => listMailboxes(true),
  });
  // Member picker source — this screen is admin-only, so the admin-gated
  // users endpoint is available here.
  const usersQuery = useQuery({
    queryKey: ["users", { isActive: "true", forMailboxPicker: true }],
    queryFn: () => listUsers({ isActive: "true" }),
  });

  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Shared Mailboxes">
      <div style={{ marginBottom: "16px" }}>
        <Link
          to="/mail"
          className="t-caption"
          style={{ display: "inline-flex", alignItems: "center", gap: "4px", color: "var(--text-secondary)" }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          {t("mail.backToMail")}
        </Link>
      </div>

      <MailboxesClient
        initialItems={mailboxesQuery.data ?? []}
        users={(usersQuery.data?.data ?? []).map((u) => ({
          id: u.id,
          displayName: u.displayName,
          email: u.email,
        }))}
        userId={session.userId}
        isFetching={mailboxesQuery.isFetching}
        isLoading={mailboxesQuery.isLoading}
      />
    </div>
  );
}
